import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let ProductList = class ProductList extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.loading = false;
        this.searchForm = {
            keyword: '',
            displayOption: 0,
        };
        this.productCategory = [];
        this.productList = [];
        this.sourceProductList = [];
        // 查看产品明细
        this.dialogDetail = {
            visible: false,
            formData: {},
        };
        this.dialogProduct = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
        };
        this.inventoryStatistic = [];
    }
    showDetailClick(row) {
        const that = this;
        that.dialogDetail.visible = true;
        that.dialogDetail.formData = { ...row };
    }
    showProductFormClick(operType, row) {
        const that = this;
        that.dialogProduct.visible = true;
        that.dialogProduct.operType = operType || 'add';
        that.dialogProduct.formData = Object.assign({ ...row }, {});
        if (that.dialogProduct.operType === 'add') {
            that.dialogProduct.title = '添加产品信息';
            that.dialogProduct.formData = {
                category: 0,
            };
        }
        else if (that.dialogProduct.operType === 'edit') {
            that.dialogProduct.title = '编辑产品信息';
        }
        else if (that.dialogProduct.operType === 'del') {
            that.dialogProduct.title = '删除产品信息';
        }
    }
    async saveProductForm() {
        const that = this;
        // 表单必填校验
        if (!(that.dialogProduct.operType == 'del')
            && !that.$refs['refFormPro'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        that.dialogProduct.loading = true;
        let month = '';
        let url = '/api/erp/sales';
        let msg = '';
        // 添加
        if (that.dialogProduct.operType == 'add') {
            month = 'post';
            msg = '添加';
            // 取用户姓名
            that.dialogProduct.formData.creator = (that.userInfo || {}).name;
        }
        else if (that.dialogProduct.operType == 'edit') {
            month = 'put';
            url += '/' + that.dialogProduct.formData.id;
            msg = '修改';
        }
        else if (that.dialogProduct.operType == 'del') {
            month = 'delete';
            url += '/' + that.dialogProduct.formData.id;
            msg = '删除';
        }
        await that.axios[month](url, that.dialogProduct.formData)
            .then((res) => {
            that.dialogProduct.loading = false;
            // 提示成功刷新页面
            that.dialogProduct.visible = false;
            that.snackbar.success(`${msg}产品成功`);
            that.getProductList();
        })
            .catch((e) => {
            that.dialogProduct.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${msg}产品错误${resMeg}`);
            console.log(`${msg}产品错误`, e);
        });
    }
    displayOptionChange() {
        const that = this;
        that.setProductList();
    }
    searchChange() {
        const that = this;
        that.setProductList();
    }
    /**
     * 获取产品列表
     */
    async getProductList() {
        const that = this;
        that.loading = true;
        await that.getInventoryStatistic();
        try {
            const res = await that.axios.get('/api/erp/sales');
            that.sourceProductList = [];
            that.productList = [];
            if (res.data && res.data.result) {
                that.sourceProductList = res.data.result;
                // 计算库存值
                that.sourceProductList.forEach((item) => {
                    const m = that.inventoryStatistic.find((e) => e.model == item.model && e.productLine == item.productLine);
                    item.usableInventory = m.usableInventory; // 可用库存
                    item.reaInventory = m.reaInventory; // 真实库存
                    item.busOutQuantity = m.busOutQuantity; // 待出库
                });
                that.setProductList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.loading = false;
        }
    }
    /**
     * 设置产品列表值
     */
    setProductList() {
        const that = this;
        const index = that.searchForm.displayOption;
        if (index == 0) {
            that.productList = that.sourceProductList || [];
        }
        else {
            const productLine = that.productCategory[index - 1];
            that.productList = (that.sourceProductList || []).filter((e) => e.productLine == productLine);
        }
        if (that.productList.length > 0 && that.searchForm.keyword) {
            // 综合查询过滤
            that.productList = that.productList.filter((e) => e.productName
                .toLowerCase()
                .indexOf(that.searchForm.keyword.toLowerCase()) > -1
                || e.productLine
                    .toLowerCase()
                    .indexOf(that.searchForm.keyword.toLowerCase()) > -1
                || e.productCode
                    .toLowerCase()
                    .indexOf(that.searchForm.keyword.toLowerCase()) > -1
                || e.shortName
                    .toLowerCase()
                    .indexOf(that.searchForm.keyword.toLowerCase()) > -1
                || e.model.toLowerCase().indexOf(that.searchForm.keyword.toLowerCase())
                    > -1);
        }
    }
    /**
     * 获取产品分类
     */
    async getProductCategory() {
        const that = this;
        // const res: any = await that.axios.get('/api/erp/category/product')
        that.productCategory = ['静配线', '洗消线', '康复线'];
        if (that.productList) {
            // 去重后添加到产品线分类中
            const pList = that.productList.map((o) => o.productLine);
            that.productCategory = (pList.filter((value, index, self) => self.indexOf(value) === index) || []).sort((a, b) => {
                const idxa = that.productCategory.indexOf(a);
                const idxb = that.productCategory.indexOf(b);
                if (idxa !== -1 && idxb !== -1)
                    return idxa - idxb;
                if (idxa === -1)
                    return 1;
                if (idxb === -1)
                    return 1;
                return a.localeCompare(b);
            });
        }
    }
    async getInventoryStatistic() {
        const that = this;
        try {
            const res = await that.axios.get('/api/erp/inventory/statistics');
            that.inventoryStatistic = res.data.result || [];
        }
        catch (e) { }
    }
    async mounted() {
        const that = this;
        await that.getProductList();
        that.getProductCategory();
    }
};
__decorate([
    Getter
], ProductList.prototype, "userInfo", void 0);
ProductList = __decorate([
    Component({
        name: 'ProductList',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], ProductList);
export default ProductList;
